import { render, staticRenderFns } from "./CodeCompatibleBadge.vue?vue&type=template&id=418930d0&scoped=true"
import script from "./CodeCompatibleBadge.vue?vue&type=script&lang=js"
export * from "./CodeCompatibleBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418930d0",
  null
  
)

export default component.exports